import { OverlayTrigger, Tooltip } from "react-bootstrap"
import uuid from "react-uuid"
import "./SortCarrot.css"

interface Props<Args extends unknown[] = []> {
  ascendingCallback: (...args: Args) => void
  descendingCallback: (...args: Args) => void
  args?: Args
  active: boolean
  activeDirection: "asc" | "desc"
}

const SortCarrot = <Args extends unknown[] = []>(props: Props<Args>) => {
  const {
    ascendingCallback,
    descendingCallback,
    args,
    active,
    activeDirection
  } = props

  const safeArgs = (args ?? []) as Args

  const sortCarrotTooltip = (text: string) => (
    <Tooltip id={uuid()}>
      {text}
    </Tooltip>
  )

  return (
    <div className="SortCarrot">
      <OverlayTrigger placement="top" overlay={sortCarrotTooltip("Sort Ascending")}>
        <span
          className={`material-icons SortCarrotArrowUp ${active && activeDirection === "asc" ? "SortCarrotActive" : ""}`}
          onClick={() => ascendingCallback(...safeArgs)}
        >
          keyboard_arrow_up
        </span>
      </OverlayTrigger>
      <OverlayTrigger placement="bottom" overlay={sortCarrotTooltip("Sort Descending")}>
        <span
          className={`material-icons SortCarrotArrowDown ${active && activeDirection === "desc" ? "SortCarrotActive" : ""}`}
          onClick={() => descendingCallback(...safeArgs)}
        >
          keyboard_arrow_down
        </span>
      </OverlayTrigger>
    </div>
  )
}

export default SortCarrot
